import { useTranslation } from 'react-i18next';
import { BotMessageSquare } from 'lucide-react';
import { useWorkspace } from '@/workspace/WorkspaceContext';
import { Badge } from '@/components/ui/badge';
import { GoogleChatTab } from '@/components/organization/GoogleChatTab';

export function GoogleChat(): JSX.Element {
  const { t } = useTranslation();
  const { currentBotId, currentBot } = useWorkspace();

  if (!currentBotId) {
    return (
      <div className="rounded-md border border-dashed p-8 text-center text-sm text-muted-foreground">
        {t('googleChatPage.selectBot', {
          defaultValue: 'Select a bot from the workspace switcher to configure its Google Chat channel.',
        })}
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <header className="flex items-center gap-3">
        <BotMessageSquare className="h-6 w-6 text-primary" />
        <div>
          <h1 className="text-2xl font-semibold">{t('googleChatPage.title', { defaultValue: 'Google Chat' })}</h1>
          <p className="text-xs text-muted-foreground">
            {t('googleChatPage.subtitle', {
              defaultValue: 'Reply as {{bot}} when @mentioned in internal Upela Google Chat spaces.',
              bot: currentBot?.name ?? currentBotId,
            })}
          </p>
        </div>
        {currentBot ? (
          <Badge variant="secondary" className="ml-auto font-mono">
            {currentBotId}
          </Badge>
        ) : null}
      </header>
      <GoogleChatTab />
    </div>
  );
}
